module.exports = __webpack_public_path__ + "media/media/about/comm-1-49ff57696b792e2c77e6daedca2b1f23.png";